// convention for constants is
// [App_Name]_[Action]
var KnowledgeBookConstants: IKnowledgeBookConstants = {
    KNOWLEDGE_BOOK_INVALID_ADD: 'KNOWLEDGE_BOOK_INVALID_ADD',
    KNOWLEDGE_BOOK_GET_ALL: 'KNOWLEDGE_BOOK_GET_ALL',
    KNOWLEDGE_BOOK_ADD: 'KNOWLEDGE_BOOK_ADD',
    KNOWLEDGE_BOOK_EDIT: 'KNOWLEDGE_BOOK_EDIT',
    KNOWLEDGE_BOOK_UPDATE: 'KNOWLEDGE_BOOK_UPDATE',
    KNOWLEDGE_BOOK_ASSIGN_TAGS_BEGIN: 'KNOWLEDGE_BOOK_ASSIGN_TAGS_BEGIN',
    KNOWLEDGE_BOOK_ASSIGN_TAGS_UPDATE: 'KNOWLEDGE_BOOK_ASSIGN_TAGS_UPDATE',
    KNOWLEDGE_BOOK_ASSIGN_TAGS_FINISH: 'KNOWLEDGE_BOOK_ASSIGN_TAGS_FINISH',
    KNOWLEDGE_BOOK_DELETE: 'KNOWLEDGE_BOOK_DELETE',
    KNOWLEDGE_BOOK_FINISH_EDIT: 'KNOWLEDGE_BOOK_FINISH_EDIT',
    KNOWLEDGE_BOOK_DETAILS: 'KNOWLEDGE_BOOK_DETAILS',
    KNOWLEDGE_BOOK_FAVORITES_GET_ALL: 'KNOWLEDGE_BOOK_FAVORITES_GET_ALL',
    KNOWLEDGE_BOOK_FAVORITE_UPDATE: 'KNOWLEDGE_BOOK_FAVORITE_UPDATE',
    KNOWLEDGE_BOOK_CLASSIFICATION_TAGS_UPDATE: 'KNOWLEDGE_BOOK_CLASSIFICATION_TAGS_UPDATE',

    KNOWLEDGE_VIEW_GET_ALL: 'KNOWLEDGE_VIEW_GET_ALL',
    KNOWLEDGE_VIEW_EDIT: 'KNOWLEDGE_VIEW_EDIT',
    KNOWLEDGE_VIEW_SAVE: 'KNOWLEDGE_VIEW_SAVE',
    KNOWLEDGE_VIEW_DELETE: 'KNOWLEDGE_VIEW_DELETE',
    KNOWLEDGE_VIEW_ADD_NEW: 'KNOWLEDGE_VIEW_ADD_NEW',
    KNOWLEDGE_BOOK_ADD_FORM: 'KNOWLEDGE_BOOK_ADD_FORM',
    KNOWLEDGE_VIEW_SELECTED_INDEX: 'KNOWLEDGE_VIEW_SELECTED_INDEX',
    SHOW_KNOWLEDGE_BOOK_DESCRIPTION: 'SHOW_KNOWLEDGE_BOOK_DESCRIPTION',
    KNOWLEDGE_BOOK_VIEWING_MODE: 'KNOWLEDGE_BOOK_VIEWING_MODE',
    ASSET_SETS_GET_ALL: 'ASSET_SETS_GET_ALL',
    UPDATE_ASSET_SET: 'UPDATE_ASSET_SET',
    KNOWLEDGE_VIEW_LIST_UPDATE: 'KNOWLEDGE_VIEW_LIST_UPDATE',
    PIN_UNPIN_KB_POPUP: 'PIN_UNPIN_KB_POPUP',
    KNOWLEDGE_VIEW_UPDATE_ALL: 'KNOWLEDGE_VIEW_UPDATE_ALL',
    KNOWLEDGE_VIEW_BEING_EDIT: 'KNOWLEDGE_VIEW_BEING_EDIT',
    KNOWLEDGE_VIEW_UPDATE: 'KNOWLEDGE_VIEW_UPDATE',
    KNOWLEDGE_VIEW_FINISH_EDIT: 'KNOWLEDGE_VIEW_FINISH_EDIT',
    KNOWLEDGE_VIEW_EDIT_FORM: 'KNOWLEDGE_VIEW_EDIT_FORM',
    KNOWLEDGE_VIEW_INVALID_ADD: 'KNOWLEDGE_VIEW_INVALID_ADD',
    KNOWLEDGE_BOOK_ASSET_SET_ADD: 'KNOWLEDGE_BOOK_ASSET_SET_ADD',
    KNOWLEDGE_BOOK_ASSET_SET_EDIT: 'KNOWLEDGE_BOOK_ASSET_SET_EDIT',
    KNOWLEDGE_BOOK_ASSET_SET_FINISH: 'KNOWLEDGE_BOOK_ASSET_SET_FINISH',
    KNOWLEDGE_BOOK_ASSET_SET_UPDATE: 'KNOWLEDGE_BOOK_ASSET_SET_UPDATE',
    KNOWLEDGE_BOOK_ASSET_SET_MODAL_OPEN: 'KNOWLEDGE_BOOK_ASSET_SET_MODAL_OPEN',
    KNOWLEDGE_BOOK_FACILITY_ASSET_SET_ADD: 'KNOWLEDGE_BOOK_FACILITY_ASSET_SET_ADD',
    KNOWLEDGE_BOOK_FACILITY_ASSET_SET_EDIT: 'KNOWLEDGE_BOOK_FACILITY_ASSET_SET_EDIT',
    KNOWLEDGE_BOOK_FACILITY_ASSET_SET_FINISH: 'KNOWLEDGE_BOOK_FACILITY_ASSET_SET_FINISH',
    KNOWLEDGE_BOOK_FACILITY_ASSET_SET_UPDATE: 'KNOWLEDGE_BOOK_FACILITY_ASSET_SET_UPDATE',
} as const;

export default KnowledgeBookConstants;
